<template >
<div >
    <v-layout v-if="!page_show">
        <not-page-spinner :not_show="true" /> 
    </v-layout>  
    <v-container v-else grid-list-l>
        <!-- <v-layout row wrap justify-center="">
            <div class="not-f9">The Sisters</div>
        </v-layout> -->
        <v-row>
            <v-col sm="9" cols="12"> 
                <v-row>
                    <v-col sm="6" md="4" cols="12" v-for="(study, index) in p_news?p_news.list:null" :key="index" class="px-1">
                        <v-card :to="'news/'+study.key" flat="" color="" height="100%" hover=""  class="px-" outlined="">
                            <v-hover v-slot:default="{hover}">
                                <v-layout column fill-height> 
                                    <!-- //IMAGE -->
                                    <div> 
                                        <div v-if="!study.image">
                                            <v-img
                                                :src="not.noImg"
                                                :lazy-src="not.imgLazy"
                                                aspect-ratio="1.5"
                                                class="grey lighten-2"/>  
                                        </div>
                                        <div v-else>
                                            <v-img
                                                :src="study.image.link"
                                                :lazy-src="not.imgLazy"
                                                aspect-ratio="1.5"
                                                class="grey lighten-2"/>  
                                        </div>
                                    </div>
                                    <!-- //CONTENT -->
                                    <v-sheet   class="px-2 pb-">
                                        <div class="px- pt-2">
                                            <v-layout class="not-f4 font-italic ">
                                               <v-icon class="pr-2">mdi-calendar</v-icon>
                                               {{not.convertDate(study.reported_date)}}
                                            </v-layout> 
                                        </div>
                                        <div class="px-">
                                            <v-layout class="not-f4">
                                                <v-icon class="pr-2">mdi-account</v-icon> By :  
                                                <div v-if="not.size(study.reported_by)<20">{{study.reported_by}}</div>
                                                <div v-else>{{study.reported_by.substring(0,20)+"..."}}</div> 
                                            </v-layout> 
                                        </div>
                                        <div class="p">
                                            <div class="not-f6 font-weight-bold ">
                                                <div v-if="not.size(study.title)<20">{{study.title}}</div>
                                                <div v-else>{{study.title.substring(0,20)+"..."}}</div> 
                                            </div> 
                                        </div> 
                                        <v-sheet min-height="110" color="">
                                            <div class= "body-2 pt-3 pb-5 text-justify">
                                                <div v-if="not.size(study.desc)<100">{{study.desc}}</div>
                                                <div v-else>{{study.desc.substring(0,100)+"..."}}</div>
                                            </div>  
                                        </v-sheet> 
                                    </v-sheet>
                                    <v-spacer></v-spacer>  
                                    <v-layout column="" justify-center="" class="pa-2">
                                        <v-divider></v-divider>
                                        <v-btn color="primary" text="">Read More</v-btn>
                                    </v-layout> 
                                </v-layout> 
                            </v-hover> 
                        </v-card>
                    </v-col> 
                </v-row> 
            </v-col>
            <v-col sm="3">
                <v-layout column=""> 
                    <v-card>
                        <v-card-title class="primary white--text">
                            SERVICES
                        </v-card-title>
                        <v-card-text>
                            <v-list single-line dense="" color="b2m">
                                <div color="b2" v-for="(item, index) in services" :key="index">
                                    <v-list-item :to="'/services/'+item.key">{{item.name}}</v-list-item>
                                    <v-divider></v-divider>
                                </div> 
                            </v-list>
                        </v-card-text> 
                    </v-card> 
                </v-layout>
            </v-col>
        </v-row>
       
        <br>
        <v-divider></v-divider>
        <div class="px-5">
            <v-pagination
                v-model="page_current"
                class="mt-4"
                :length="p_news?p_news.pages:0"/> 
        </div>
    </v-container>
   
</div>
</template>

<script>
    let pageName = "News"
    export default{
        props:["id","not"],
        name: pageName,  
        data: () => ({
            page_show: false,   
            page_current:1,
            page_size:12,
            images:[
                {src:require(`@/assets/awrim/group/g6.jpeg`),local:true},  
            ],
           
        }),
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notImages:this.images,
                notText:false,
                notIndicators:true,
                notHeight:350
            })
            this.pageLoad(500)
        },
        //---------computed-----------
        computed: { 
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },


            services(){
                return this.$store.getters.getServices
            },
            programs(){
                return this.$store.getters.getPrograms
            }, 
            news(){
                return this.$store.getters.getNews
            }, 
            p_news(){
                if (!this.JOINED_news) {
                    return null
                }
                let list = [...this.JOINED_news]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            },
            JOINED_news(){
                let news = this.news 
                let joinNews = this.not.JOIN_NEWS(news)
                return joinNews
            },
        },

        //--------methods-----------
        methods:{
             
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //CHECK USER STATE
                    if (ps.indexOf('logging')!==-1) { 
                        this.page_show = false
                    } else {   
                        this.page_show = true
                    } 

                    //Check proccess 
                    if (ps.indexOf('add/bibleStudy')!==-1) {
                        this.not.notDialogP(true,true,'adding...') 
                    }else{
                        this.not.notDialogP(false) 
                    }  

                    if (ps.indexOf('delete/bibleStudy')!==-1) {
                        this.not.notDialogP(true,true,'delete...') 
                    }else{
                        this.not.notDialogP(false) 
                    } 

                    //check response
                    if (res.res==='add/bibleStudy/successful') { 
                        this.not.notDialog(true,true,'Successful','Bible study, successfuly added.','','OK',{code:2}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='add/bibleStudy/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding bible study.','Cancel','Try again',{code:3}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='delete/bibleStudy/successful') { 
                        this.not.notDialog(true,true,'Successful','Bible study, successfuly deleted.','','OK',{code:5})
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='delete/bibleStudy/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting bible study.','Cancel','Try again',{code:5}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },t)
            }
        }, 
        watch: {
            us(v){
                 
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>

 